import clsx from "clsx";
import { observer } from "mobx-react-lite";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { getSelectedOrganization } from "../../../helpers/localStorage.ts";
import { useAppStore } from "../../../hooks/useStores.tsx";
import raStyles from "../../TailoredGeneration/RequestAccessContainer/RequestAccessContainer.module.scss";
import ConfirmationPopup from "../ConfirmationPopup/ConfirmationPopup.tsx";
import RequestAccessForm from "../RequestAccessForm/RequestAccessForm";
import styles from "./DownloadModelPopup.module.scss";

type Props = {
	open: boolean;
	onClose: () => void;
	requestFeature: string;
	title?: string;
	description?: string;
	modelId?: string;
	modelName?: string;
	projectId?: string;
	projectName?: string;
	paperClassName?: string;
};

const DownloadModelPopup = ({
	open,
	onClose,
	requestFeature,
	title,
	description,
	modelId,
	modelName,
	projectId,
	projectName,
	paperClassName,
}: Props) => {
	const { t } = useTranslation("common", { keyPrefix: "requestAccessContainer" });
	const { appStore, authStore } = useAppStore();

	const [message, setMessage] = useState("");
	const [phoneNumber, setPhoneNumber] = useState("");
	const [openSuccess, setOpenSuccess] = useState(false);

	const submit = async () => {
		const userEmail = authStore?.user?.email || "";
		const userName = authStore?.user?.userName || "";
		const orgName = getSelectedOrganization()?.organization.name || "";
		const ok = await appStore.sendRequestAccess(
			userName,
			userEmail,
			orgName,
			message,
			phoneNumber,
			requestFeature,
			modelId,
			modelName,
			projectId,
			projectName,
		);
		if (ok) {
			onClose();
			setOpenSuccess(true);
		}
	};

	return (
		<>
			<ConfirmationPopup
				open={open}
				onClose={onClose}
				onClick={submit}
				title={title || t("requestAccess.title")}
				description={description || t("requestAccess.description")}
				confirmButtonText={t("requestAccess.primaryButton")}
				hideCancel
				paperClassName={clsx(raStyles.requestAccessCustomPaperClass, paperClassName || styles.paper)}
				loading={appStore.isSendRequestAccessLoading}
			>
				<RequestAccessForm
					setMessage={setMessage}
					message={message}
					setPhoneNumber={setPhoneNumber}
					phoneNumber={phoneNumber}
				/>
			</ConfirmationPopup>

			<ConfirmationPopup
				onClose={() => setOpenSuccess(false)}
				title={t("successRequestAccess.title")}
				description={t("successRequestAccess.description")}
				confirmButtonText={t("successRequestAccess.primaryButton")}
				open={openSuccess}
				onClick={async () => setOpenSuccess(false)}
				hideCancel
				paperClassName={raStyles.customPaperClass}
			/>
		</>
	);
};

export default observer(DownloadModelPopup);
